"use client";

import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList, navigationMenuTriggerStyle } from "@/components/ui/navigation-menu";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { cn } from "@/lib/utils";
function HeaderContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsMobileMenuOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const toggleMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  return <div data-section-id="31394" className="container mx-auto px-4 h-full flex items-center justify-between font-sans">
      {}
      <Link to="/" className="flex-shrink-0 z-50">
        <img src="https://moonriseresidentialcare.com/wp-content/uploads/2026/06/MoonRise-transparent-01-scaled.png" alt="Moonrise Residential Care" className="h-80 w-auto object-contain" />
      </Link>

      {}
      <div className="hidden md:flex flex-1 justify-center">
        {loading ? <div className="flex gap-4">
            {[1, 2, 3, 4].map(i => <div key={i} className="h-4 w-20 bg-muted animate-pulse rounded" />)}
          </div> : <NavigationMenu>
            <NavigationMenuList className="gap-1">
              {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
                  <NavigationMenuLink asChild>
                    <Link to={item.href || "#"} className={cn(navigationMenuTriggerStyle(), "bg-transparent hover:bg-accent/10 text-xl font-bold text-[#091b3a] hover:text-[#ffbd00] transition-colors relative group px-5")}>
                      {item.label}
                    </Link>
                  </NavigationMenuLink>
                </NavigationMenuItem>)}
            </NavigationMenuList>
          </NavigationMenu>}
      </div>

      {}
      <div className="hidden md:flex items-center gap-4">
        <Button asChild className="bg-[#ffbd00] text-black hover:bg-[#ffbd00]/90 shadow-md hover:shadow-lg transition-all duration-300 rounded-lg font-bold tracking-wide px-10 h-12 text-lg">
          <Link to="#">Book Assessment</Link>
        </Button>
      </div>

      {}
      <div className="flex md:hidden items-center gap-4 z-50 relative">
        <Button variant="ghost" size="icon" onClick={toggleMenu} className="text-[#091b3a] hover:text-[#ffbd00] hover:bg-transparent" aria-label="Toggle menu">
          {isMobileMenuOpen ? <X className="h-6 w-6 text-[#ffbd00]" /> : <Menu className="h-6 w-6 text-[#ffbd00]" />}
        </Button>
      </div>

      {}
      <div className={cn("fixed inset-0 bg-white/98 backdrop-blur-2xl z-40 flex flex-col items-center justify-center transition-all duration-300 md:hidden", isMobileMenuOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none")}>
        <nav className="flex flex-col items-center gap-8 w-full px-6">
          {loading ? <div className="flex flex-col gap-4 items-center">
              {[1, 2, 3].map(i => <div key={i} className="h-6 w-32 bg-muted animate-pulse rounded" />)}
            </div> : menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} className="text-3xl font-bold text-[#091b3a] hover:text-[#ffbd00] transition-colors" onClick={() => setIsMobileMenuOpen(false)} data-index={i}>
                {item.label}
              </Link>)}
          <div className="mt-8 w-full max-w-xs">
            <Button asChild className="w-full h-14 text-lg shadow-lg rounded-lg bg-[#ffbd00] text-black hover:bg-[#ffbd00]/90 font-bold">
              <Link to="#" onClick={() => setIsMobileMenuOpen(false)}>
                Book Assessment
              </Link>
            </Button>
          </div>
        </nav>
      </div>
    </div>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="header" className={cn("sticky top-0 z-50 w-full transition-all duration-300 border-b bg-background text-foreground", isScrolled ? "bg-white/80 backdrop-blur-md border-border/40 shadow-md py-3" : "bg-white border-transparent py-6")}>
      <MenuProvider menu_id="61" className="h-full">
        <HeaderContent />
      </MenuProvider>
    </header>;
}